import { isFeatureEnabled } from 'owa-feature-flags';
import type {
    ApplicationSettings,
    ApplicationSettingGroup,
} from '../store/schema/ApplicationSettings';
import getStore from '../store/store';
import { raiseAlertForDefaultSettings } from '../utils/allowDefaultApplicationSettings';
import type { MailboxInfo } from 'owa-client-types';

function updateSettingsWithOverrides(
    settings: Record<string, any>,
    overrides: Record<string, any>,
    path: any
) {
    let result = {};

    Object.keys(settings).forEach(setting => {
        const isGroup = typeof setting === 'object' && setting !== null && !Array.isArray(setting);

        if (isGroup) {
            result = {
                ...result,
                [path.shift()]: updateSettingsWithOverrides(settings[setting], overrides, path),
            };
        } else {
            const settingPath = [...path, setting].join('.');
            const override = overrides[settingPath];
            result = {
                ...result,
                [setting]: override === undefined ? settings[setting] : override,
            };
        }
    });

    return result;
}

export default function getApplicationSettings<TGroup extends ApplicationSettingGroup>(
    group: TGroup,
    mailboxInfo?: MailboxInfo,
    dontErrorIfNotInitialized?: boolean
): ApplicationSettings[TGroup] {
    const store = getStore(mailboxInfo);
    if (!store.initialized && !process.env.JEST_WORKER_ID) {
        raiseAlertForDefaultSettings(mailboxInfo, group, dontErrorIfNotInitialized);
    }

    if (isFeatureEnabled('fwk-devTools')) {
        return updateSettingsWithOverrides(store.settings[group], store.overrides, [group]) as any;
    }

    return store.settings[group];
}
